import { __extends } from "tslib";
import { AssetEvent } from '@awayjs/core';
import { PartitionBase, EntityNode } from '@awayjs/view';
import { Graphics } from '@awayjs/graphics';
import { DisplayObjectContainer } from './DisplayObjectContainer';
import { DisplayObject } from './DisplayObject';
/**
 * Sprite is an instance of a Graphics, augmenting it with a presence in the scene graph, a material, and an animation
 * state. It consists out of Graphices, which in turn correspond to SubGeometries. Graphices allow different parts
 * of the graphics to be assigned different materials.
 */
var Sprite = /** @class */ (function (_super) {
    __extends(Sprite, _super);
    /**
     * Create a new Sprite object.
     *
     * @param material    [optional]        The material with which to render the Sprite.
     */
    function Sprite(graphics, material) {
        if (graphics === void 0) { graphics = null; }
        if (material === void 0) { material = null; }
        var _this = _super.call(this) || this;
        _this._isEntity = false;
        _this._onGraphicsInvalidateDelegate = function (event) { return _this._onGraphicsInvalidate(event); };
        _this.graphics = graphics || Graphics.getGraphics();
        _this.material = material;
        return _this;
    }
    Sprite.getNewSprite = function (graphics, material) {
        if (graphics === void 0) { graphics = null; }
        if (material === void 0) { material = null; }
        if (Sprite._sprites.length) {
            var sprite = Sprite._sprites.pop();
            sprite.graphics = graphics || Graphics.getGraphics();
            sprite.material = material;
            return sprite;
        }
        return new Sprite(graphics, material);
    };
    Sprite.clearPool = function () {
        Sprite._sprites = [];
    };
    Object.defineProperty(Sprite.prototype, "assetType", {
        /**
         *
         */
        get: function () {
            return Sprite.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Sprite.prototype, "graphics", {
        /**
         * Specifies the Graphics object belonging to this Sprite object, where
         * drawing commands can occur.
         */
        get: function () {
            if (this._iSourcePrefab)
                this._iSourcePrefab._iValidate();
            if (this.isSlice9ScaledSprite) {
                //var comps:Array<Vector3D> = this.transform.concatenatedMatrix3D.decompose();
                this._graphics.updateSlice9(this.parent.scaleX, this.parent.scaleY);
            }
            return this._graphics;
        },
        set: function (value) {
            if (value == null)
                throw new Error('Cannot have graphics set to null');
            this._setGraphics(value);
        },
        enumerable: true,
        configurable: true
    });
    Sprite.prototype._setGraphics = function (value) {
        if (this._graphics == value) {
            return;
        }
        if (this._graphics) {
            this._graphics.removeEventListener(AssetEvent.INVALIDATE, this._onGraphicsInvalidateDelegate);
            this._graphics.usages--;
            //if (!this._graphics.usages)
            //	this.graphics.dispose();
        }
        this._graphics = value;
        this._graphics.usages++;
        this._onGraphicsInvalidate(null);
    };
    Sprite.prototype._setParent = function (parent) {
        _super.prototype._setParent.call(this, parent);
        if (parent)
            this._graphics.addEventListener(AssetEvent.INVALIDATE, this._onGraphicsInvalidateDelegate);
        else
            this._graphics.removeEventListener(AssetEvent.INVALIDATE, this._onGraphicsInvalidateDelegate);
    };
    Sprite.prototype.isEntity = function () {
        return Boolean(this._scrollRect || (this._graphics && this._graphics.count));
    };
    /**
     * @inheritDoc
     */
    Sprite.prototype.dispose = function () {
        this.disposeValues();
        Sprite._sprites.push(this);
    };
    /**
     * @inheritDoc
     */
    Sprite.prototype.disposeValues = function () {
        _super.prototype.disposeValues.call(this);
    };
    /**
     * Clones this Sprite instance along with all it's children, while re-using the same
     * material, graphics and animation set. The returned result will be a copy of this sprite,
     * containing copies of all of it's children.
     *
     * Properties that are re-used (i.e. not cloned) by the new copy include name,
     * graphics, and material. Properties that are cloned or created anew for the copy
     * include subSpritees, children of the sprite, and the animator.
     *
     * If you want to copy just the sprite, reusing it's graphics and material while not
     * cloning it's children, the simplest way is to create a new sprite manually:
     *
     * <code>
     * var clone : Sprite = new Sprite(original.graphics, original.material);
     * </code>
     */
    Sprite.prototype.clone = function () {
        var newInstance = Sprite.getNewSprite();
        this.copyTo(newInstance);
        return newInstance;
    };
    Sprite.prototype.copyTo = function (sprite, cloneShapes) {
        if (cloneShapes === void 0) { cloneShapes = false; }
        _super.prototype.copyTo.call(this, sprite);
        sprite._iSourcePrefab = this._iSourcePrefab;
        this._graphics.copyTo(sprite._graphics, cloneShapes);
    };
    /**
     *
     */
    Sprite.prototype._iInternalUpdate = function () {
        _super.prototype._iInternalUpdate.call(this);
        // if(this.parent)
        // 	this._graphics.updateScale(view);
    };
    /**
     * //TODO
     *
     * @private
     */
    Sprite.prototype._onGraphicsInvalidate = function (event) {
        var isEntity = this.isEntity();
        if (this._isEntity != isEntity) {
            if (!isEntity && this._implicitPartition)
                this._implicitPartition.clearEntity(this);
            this._isEntity = isEntity;
        }
        this.invalidate();
    };
    /**
     *
     * @param renderer
     *
     * @internal
     */
    Sprite.prototype._acceptTraverser = function (traverser) {
        _super.prototype._acceptTraverser.call(this, traverser);
        this.graphics._acceptTraverser(traverser);
    };
    /**
     *
     */
    Sprite.prototype.bakeTransformations = function () {
        this._graphics.applyTransformation(this.transform.matrix3D);
        this.transform.clearMatrix3D();
    };
    Sprite._sprites = new Array();
    Sprite.assetType = '[asset Sprite]';
    return Sprite;
}(DisplayObjectContainer));
export { Sprite };
DisplayObject._scrollRectSpriteClass = Sprite;
PartitionBase.registerAbstraction(EntityNode, Sprite);
